import React, { useState, useRef } from 'react';
import { Modal, Button, Form, Alert } from 'react-bootstrap';
import PropTypes from 'prop-types';
import axios from 'axios';
import { API_BASE_URL } from '../../../config/ApiConfig';

const UploadImagemModal = ({ isOpen, onClose, onSuccess, appCliente }) => {
  const [file, setFile] = useState(null);
  const [orientacao, setOrientacao] = useState('');
  const [previewImage, setPreviewImage] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const token = localStorage.getItem('token');
  const fileInputRef = useRef(null);

  const handleFileChange = e => {
    const selectedFile = e.target.files[0];
    if (selectedFile && selectedFile.type === 'image/png') {
      setFile(selectedFile);
      // Criar preview da imagem
      const reader = new FileReader();
      reader.onload = e => setPreviewImage(e.target.result);
      reader.readAsDataURL(selectedFile);
      setError(null);
    } else {
      setFile(null);
      setPreviewImage(null);
      setError('Por favor, selecione um arquivo PNG.');
    }
  };

  const handleOrientacaoChange = e => {
    setOrientacao(e.target.value);
    setError(null);
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (!file || !orientacao) {
      setError('Por favor, selecione a orientação e um arquivo.');
      return;
    }

    if (!appCliente?.cnpj) {
      setError('CNPJ não encontrado.');
      return;
    }

    setIsSubmitting(true);
    setError(null);

    const formData = new FormData();
    formData.append('file', file);
    formData.append('orientacao', orientacao);
    formData.append('cnpj', appCliente.cnpj);

    try {
      const response = await axios.post(
        `${API_BASE_URL.APP_IMAGES}/save`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (onSuccess) {
        onSuccess(response.data);
      }
      handleClose();
    } catch (error) {
      console.error('Erro ao enviar o template:', error);
      setError(error.response?.data || 'Erro ao enviar o template.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    setOrientacao('');
    setFile(null);
    setPreviewImage(null);
    setError(null);
    setIsSubmitting(false);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
    onClose();
  };

  return (
    <Modal show={isOpen} onHide={handleClose} size="md" centered>
      <div className="modal-header text-white py-1" style={{ background: 'linear-gradient(90deg, #0b3383, #0e48ad)' }}>
        <h6 className="modal-title text-center m-0">
          <i className="bi bi-cloud-upload me-2"></i>
          Upload de Imagem
        </h6>
        <button
          className="btn btn-link text-white p-0 mb-0"
          onClick={handleClose}
          title="Fechar"
          style={{ fontSize: '0.9rem', textDecoration: 'none' }}
        >
          <i className="bi bi-x-lg"></i>
        </button>
      </div>

      <Modal.Body>
        {error && (
          <Alert variant="danger" className="mb-3">
            <i className="bi bi-exclamation-triangle me-2"></i>
            {error}
          </Alert>
        )}

        <Form onSubmit={handleSubmit}>
          <div className="row g-3">
            <div className="col-12">
              <Form.Label className="fw-semibold">
                Orientação da Imagem
              </Form.Label>
              <Form.Select
                value={orientacao}
                onChange={handleOrientacaoChange}
                required
                disabled={isSubmitting}
              >
                <option value="">Selecione a orientação...</option>
                <option value="P">PAISAGEM</option>
                <option value="R">RETRATO</option>
              </Form.Select>
            </div>

            <div className="col-12">
              <Form.Label className="fw-semibold">Arquivo PNG</Form.Label>
              <Form.Control
                type="file"
                onChange={handleFileChange}
                ref={fileInputRef}
                accept="image/png"
                required
                disabled={isSubmitting}
              />
              <Form.Text className="text-muted">
                Apenas arquivos PNG são aceitos
              </Form.Text>
            </div>

            {previewImage && (
              <div className="col-12">
                <Form.Label className="fw-semibold">Preview</Form.Label>
                <div className="border rounded p-2 text-center bg-light">
                  <img
                    src={previewImage}
                    alt="Preview"
                    style={{
                      maxWidth: '100%',
                      maxHeight: '200px',
                      objectFit: 'contain',
                    }}
                    className="rounded"
                  />
                </div>
              </div>
            )}
          </div>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={handleClose}
          disabled={isSubmitting}
        >
          <i className="bi bi-x-lg me-2"></i>
          Cancelar
        </Button>
        <Button
          variant="success"
          onClick={handleSubmit}
          disabled={isSubmitting || !file || !orientacao}
        >
          {isSubmitting ? (
            <>
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
              Enviando...
            </>
          ) : (
            <>
              <i className="bi bi-upload me-2"></i>
              Enviar
            </>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

UploadImagemModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func,
  appCliente: PropTypes.object,
};

export default UploadImagemModal;
